export default "__VITE_ASSET__CvfQmL2C__"